import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { RestService } from "../rest.service";
import { Router } from "@angular/router";
import { catchError, retry } from "rxjs/operators";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { SystemUtils } from "../utils/system.utils";

@Component({
  selector: "app-maintenance-single-selection",
  templateUrl: "./maintenance-single-selection.component.html",
  styleUrls: ["./maintenance-single-selection.component.css"],
})
export class MaintenanceSingleSelectionComponent implements OnInit {
  isValidate: boolean = false;
  isLoadingIcon: boolean = false;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";

  envList: any = [];
  systemList: any = [];
  isSystemAccess: boolean = false;
  isMaintenanceClicked: boolean = false;
  isSystemAccessClicked: boolean = false;
  isSAError: boolean = false;
  selectedEnvironment: any;

  constructor(
    private formBuilder: FormBuilder,
    private _restService: RestService,
    private router: Router
  ) {}

  @Output() gobacktostep1 = new EventEmitter<any>();
  @Output() mSingleStep2Data = new EventEmitter<any>();
  @Output() getMEnvID = new EventEmitter<any>();

  ngOnInit() {
    this.isLoadingIcon = true;

    this._restService
      .environmentList()
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => ((this.envList = f.EnvList), (this.isLoadingIcon = false))
      );
  }

  maintenanceSingleSelect = this.formBuilder.group({
    activityLabel: ["", Validators.required],
    environment: ["", Validators.required],
    description: ["", Validators.required],
    mtnForAllEvn: [false]
  });

  back() {
    this.gobacktostep1.emit();
  }

  mStep2Event() {
    this.isValidate = true;
    let list = this.systemList;
    let systemAccessList = [];
    let filteredList = [];

    console.log("maintenanceType", this.maintenanceSingleSelect);

    list.map(
      (a: any) => (
        systemAccessList.push(a),
        a.hasOwnProperty("children")
          ? a.children.map(
              (b: any) => (
                systemAccessList.push(b),
                b.hasOwnProperty("children")
                  ? b.children.map(
                      (c: any) => (
                        systemAccessList.push(c),
                        c.hasOwnProperty("children")
                          ? c.children.map(
                              (d: any) => (
                                systemAccessList.push(d),
                                d.hasOwnProperty("children")
                                  ? d.children.map(
                                      (f: any) => (
                                        systemAccessList.push(f),
                                        f.hasOwnProperty("children")
                                          ? f.children.map(
                                              (g: any) => (
                                                systemAccessList.push(g),
                                                g.hasOwnProperty("children")
                                                  ? g.children.map(
                                                      (h: any) => (
                                                        systemAccessList.push(
                                                          h
                                                        ),
                                                        h.hasOwnProperty(
                                                          "children"
                                                        )
                                                          ? h.children.map(
                                                              (j: any) => (
                                                                systemAccessList.push(
                                                                  j
                                                                ),
                                                                j.hasOwnProperty(
                                                                  "children"
                                                                )
                                                                  ? j.children.map(
                                                                      (
                                                                        k: any
                                                                      ) => (
                                                                        systemAccessList.push(
                                                                          k
                                                                        ),
                                                                        k.hasOwnProperty(
                                                                          "children"
                                                                        )
                                                                          ? k.children.map(
                                                                              (
                                                                                l: any
                                                                              ) =>
                                                                                systemAccessList.push(
                                                                                  l
                                                                                )
                                                                            )
                                                                          : ""
                                                                      )
                                                                    )
                                                                  : ""
                                                              )
                                                            )
                                                          : ""
                                                      )
                                                    )
                                                  : ""
                                              )
                                            )
                                          : ""
                                      )
                                    )
                                  : ""
                              )
                            )
                          : ""
                      )
                    )
                  : ""
              )
            )
          : ""
      )
    );

    this.isSystemAccessClicked === true
      ? (this.isSAError = false)
      : (this.isSAError = true);

    this.maintenanceSingleSelect.status === "VALID" &&
    this.isSystemAccessClicked === true
      ? systemAccessList.map(
          (a: any) => (
            a.hasOwnProperty("children") ? delete a.children : "",
            a.hasOwnProperty("envList") ? delete a.envList : ""
          )
        )
      : "";

    systemAccessList.filter((f: any) =>
      f.isMainteanceChecked === true ? filteredList.push(f) : ""
    );

    if (this.maintenanceSingleSelect.value.mtnForAllEvn){
      
      const allEvn = {
        Description: this.maintenanceSingleSelect.value.description,
        LevelNumber: 1,
        ShowChild: true,
        alias: this.selectedEnvironment.Environment_Name,
        categoryId: 0,
        category_Name: this.selectedEnvironment.Environment_Name,
        isEdited: false,
        isEnabled: true,
        isMainteanceChecked: true,
        parentId: 0
      }

      filteredList.push(allEvn);
    }

    console.log("Fianl Array ------>>>>>>", filteredList);

    this.maintenanceSingleSelect.status === "VALID" &&
    this.isSystemAccessClicked
      ? this.mSingleStep2Data.emit({
          systemAccess: filteredList,
          activityLabel: this.maintenanceSingleSelect.value.activityLabel,
          environment: this.maintenanceSingleSelect.value.environment,
          description: this.maintenanceSingleSelect.value.description,
          mtnForAllEvn: this.maintenanceSingleSelect.value.mtnForAllEvn
        })
      : "";
  }

  selectEnvironment(e: any) {
    console.log("selectEnvironment", e.target.value);
    var eid = e.target.value.toString();

    this.envList.filter((m: any) => {
      if (parseInt(m.id) === parseInt(eid)) {
        this.getMEnvID.emit(m.MasterEnvId);
        this.selectedEnvironment = m;
      }
    });

    this.isLoadingIcon = true;
    this.systemList = [];
    this._restService
      .getsystemAccess(eid, "0")
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.systemList = f.systemAccess),
          ( SystemUtils.sortSystemAccess(this.systemList)),
          (this.isSystemAccess = true),
          (this.isLoadingIcon = false),
          console.log("Lists --======->", this.systemList)
        )
      );
  }

  maintenanceScheduledEvent(e: any) {
    let isChecked = e.target.checked;
    let list = this.systemList;

    isChecked
      ? ((this.isMaintenanceClicked = true),
        (this.isSystemAccessClicked = true))
      : ((this.isMaintenanceClicked = false),
        (this.isSystemAccessClicked = false));

    // Uncheck all Maintenance for 
    isChecked = false;

    list.map(
      (a: any) => (
        (a.isMainteanceChecked = isChecked),
        a.hasOwnProperty("children")
          ? a.children.map(
              (b: any) => (
                (b.isMainteanceChecked = isChecked),
                b.hasOwnProperty("children")
                  ? b.children.map(
                      (c: any) => (
                        (c.isMainteanceChecked = isChecked),
                        c.hasOwnProperty("children")
                          ? c.children.map(
                              (d: any) => (
                                (d.isMainteanceChecked = isChecked),
                                d.hasOwnProperty("children")
                                  ? d.children.map(
                                      (f: any) => (
                                        (f.isMainteanceChecked = isChecked),
                                        f.hasOwnProperty("children")
                                          ? f.children.map(
                                              (g: any) => (
                                                (g.isMainteanceChecked = isChecked),
                                                g.hasOwnProperty("children")
                                                  ? g.children.map(
                                                      (h: any) => (
                                                        (h.isMainteanceChecked = isChecked),
                                                        h.hasOwnProperty(
                                                          "children"
                                                        )
                                                          ? h.children.map(
                                                              (j: any) => (
                                                                (j.isMainteanceChecked = isChecked),
                                                                j.hasOwnProperty(
                                                                  "children"
                                                                )
                                                                  ? j.children.map(
                                                                      (
                                                                        k: any
                                                                      ) => (
                                                                        (k.isMainteanceChecked = isChecked),
                                                                        k.hasOwnProperty(
                                                                          "children"
                                                                        )
                                                                          ? k.children.map(
                                                                              (
                                                                                l: any
                                                                              ) =>
                                                                                (l.isMainteanceChecked = isChecked)
                                                                            )
                                                                          : ""
                                                                      )
                                                                    )
                                                                  : ""
                                                              )
                                                            )
                                                          : ""
                                                      )
                                                    )
                                                  : ""
                                              )
                                            )
                                          : ""
                                      )
                                    )
                                  : ""
                              )
                            )
                          : ""
                      )
                    )
                  : ""
              )
            )
          : ""
      )
    );
  }

  isChecked(c1: any) {
    //alert(c1);
    let count = 0;
    let list = this.systemList;
    list.map((f: any) =>
      f.categoryId === c1
        ? (f.isMainteanceChecked = !f.isMainteanceChecked)
        : ""
    ),
      list.map((f: any) =>
        f.parentId === 0
          ? f.isMainteanceChecked === true
            ? (count = count + 1)
            : ""
          : ""
      ),
      count > 0
        ? (this.isSystemAccessClicked = true)
        : (this.isSystemAccessClicked = false);
    list.map((a: any) =>
      a.hasOwnProperty("children")
        ? a.children.map((b: any) =>
            b.categoryId === c1
              ? (b.isMainteanceChecked = !b.isMainteanceChecked)
              : b.hasOwnProperty("children")
              ? b.children.map((c: any) =>
                  c.categoryId === c1
                    ? (c.isMainteanceChecked = !c.isMainteanceChecked)
                    : c.hasOwnProperty("children")
                    ? c.children.map((d: any) =>
                        d.categoryId === c1
                          ? (d.isMainteanceChecked = !d.isMainteanceChecked)
                          : d.hasOwnProperty("children")
                          ? d.children.map((f: any) =>
                              f.categoryId === c1
                                ? (f.isMainteanceChecked = !f.isMainteanceChecked)
                                : f.hasOwnProperty("children")
                                ? f.children.map((g: any) =>
                                    g.categoryId === c1
                                      ? (g.isMainteanceChecked = !g.isMainteanceChecked)
                                      : g.hasOwnProperty("children")
                                      ? g.children.map((h: any) =>
                                          h.categoryId === c1
                                            ? (h.isMainteanceChecked = !h.isMainteanceChecked)
                                            : h.hasOwnProperty("children")
                                            ? h.children.map((j: any) =>
                                                j.categoryId === c1
                                                  ? (j.isMainteanceChecked = !j.isMainteanceChecked)
                                                  : j.hasOwnProperty("children")
                                                  ? j.children.map((k: any) =>
                                                      k.categoryId === c1
                                                        ? (k.isMainteanceChecked = !k.isMainteanceChecked)
                                                        : k.hasOwnProperty(
                                                            "children"
                                                          )
                                                        ? k.children.map(
                                                            (l: any) =>
                                                              l.categoryId ===
                                                              c1
                                                                ? (l.isMainteanceChecked = !l.isMainteanceChecked)
                                                                : ""
                                                          )
                                                        : ""
                                                    )
                                                  : ""
                                              )
                                            : ""
                                        )
                                      : ""
                                  )
                                : ""
                            )
                          : ""
                      )
                    : ""
                )
              : ""
          )
        : ""
    );

    list.map((a: any) =>
      a.categoryId === c1
        ? a.isMainteanceChecked === false
          ? this.parentChildRelation(c1, a.children, false)
          : this.parentChildRelation(c1, a.children, true)
        : a.hasOwnProperty("children")
        ? a.children.map((b: any) =>
            b.categoryId === c1
              ? b.isMainteanceChecked === false
                ? this.parentChildRelation(c1, b.children, false)
                : this.parentChildRelation(c1, b.children, true)
              : b.hasOwnProperty("children")
              ? b.children.map((c: any) =>
                  c.categoryId === c1
                    ? c.isMainteanceChecked === false
                      ? this.parentChildRelation(c1, c.children, false)
                      : this.parentChildRelation(c1, c.children, true)
                    : c.hasOwnProperty("children")
                    ? c.children.map((d: any) =>
                        d.categoryId === c1
                          ? d.isMainteanceChecked === false
                            ? this.parentChildRelation(c1, d.children, false)
                            : this.parentChildRelation(c1, d.children, true)
                          : d.hasOwnProperty("children")
                          ? d.children.map((f: any) =>
                              f.categoryId === c1
                                ? f.isMainteanceChecked === false
                                  ? this.parentChildRelation(
                                      c1,
                                      f.children,
                                      false
                                    )
                                  : this.parentChildRelation(
                                      c1,
                                      f.children,
                                      true
                                    )
                                : f.hasOwnProperty("children")
                                ? f.children.map((g: any) =>
                                    g.categoryId === c1
                                      ? g.isMainteanceChecked === false
                                        ? this.parentChildRelation(
                                            c1,
                                            g.children,
                                            false
                                          )
                                        : this.parentChildRelation(
                                            c1,
                                            g.children,
                                            true
                                          )
                                      : g.hasOwnProperty("children")
                                      ? g.children.map((h: any) =>
                                          h.categoryId === c1
                                            ? h.isMainteanceChecked === false
                                              ? this.parentChildRelation(
                                                  c1,
                                                  h.children,
                                                  false
                                                )
                                              : this.parentChildRelation(
                                                  c1,
                                                  h.children,
                                                  true
                                                )
                                            : h.hasOwnProperty("children")
                                            ? h.children.map((j: any) =>
                                                j.categoryId === c1
                                                  ? j.isMainteanceChecked ===
                                                    false
                                                    ? this.parentChildRelation(
                                                        c1,
                                                        j.children,
                                                        false
                                                      )
                                                    : this.parentChildRelation(
                                                        c1,
                                                        j.children,
                                                        true
                                                      )
                                                  : j.hasOwnProperty("children")
                                                  ? j.children.map((k: any) =>
                                                      k.categoryId === c1
                                                        ? k.isMainteanceChecked ===
                                                          false
                                                          ? this.parentChildRelation(
                                                              c1,
                                                              k.children,
                                                              false
                                                            )
                                                          : this.parentChildRelation(
                                                              c1,
                                                              k.children,
                                                              true
                                                            )
                                                        : k.hasOwnProperty(
                                                            "children"
                                                          )
                                                        ? k.children.map(
                                                            (l: any) =>
                                                              l.categoryId ===
                                                              c1
                                                                ? l.isMainteanceChecked ===
                                                                  false
                                                                  ? this.parentChildRelation(
                                                                      c1,
                                                                      l.children,
                                                                      false
                                                                    )
                                                                  : this.parentChildRelation(
                                                                      c1,
                                                                      l.children,
                                                                      true
                                                                    )
                                                                : l.hasOwnProperty(
                                                                    "children"
                                                                  )
                                                                ? l.children.map(
                                                                    (m: any) =>
                                                                      m.categoryId ===
                                                                      c1
                                                                        ? m.isMainteanceChecked ===
                                                                          false
                                                                          ? this.parentChildRelation(
                                                                              c1,
                                                                              m.children,
                                                                              false
                                                                            )
                                                                          : this.parentChildRelation(
                                                                              c1,
                                                                              m.children,
                                                                              true
                                                                            )
                                                                        : ""
                                                                  )
                                                                : ""
                                                          )
                                                        : ""
                                                    )
                                                  : ""
                                              )
                                            : ""
                                        )
                                      : ""
                                  )
                                : ""
                            )
                          : ""
                      )
                    : ""
                )
              : ""
          )
        : ""
    );
  }

  parentChildRelation(c1: any, childArray: any, status: any) {
    console.log(c1);
    console.log(childArray);

    console.log("Before asasas ---->>>>", this.systemList);

    let disabledArray: any;

    status === false
      ? childArray.map(
          (a: any) => (
            (a.isMainteanceChecked = false),
            a.hasOwnProperty("children")
              ? a.children.map(
                  (b: any) => (
                    (b.isMainteanceChecked = false),
                    b.hasOwnProperty("children")
                      ? b.children.map(
                          (c: any) => (
                            (c.isMainteanceChecked = false),
                            c.hasOwnProperty("children")
                              ? c.children.map(
                                  (d: any) => (
                                    (d.isMainteanceChecked = false),
                                    d.hasOwnProperty("children")
                                      ? d.children.map(
                                          (f: any) => (
                                            (f.isMainteanceChecked = false),
                                            f.hasOwnProperty("children")
                                              ? f.children.map(
                                                  (g: any) => (
                                                    (g.isMainteanceChecked = false),
                                                    g.hasOwnProperty("children")
                                                      ? g.children.map(
                                                          (h: any) => (
                                                            (h.isMainteanceChecked = false),
                                                            h.hasOwnProperty(
                                                              "children"
                                                            )
                                                              ? h.children.map(
                                                                  (j: any) => (
                                                                    (j.isMainteanceChecked = false),
                                                                    j.hasOwnProperty(
                                                                      "children"
                                                                    )
                                                                      ? j.children.map(
                                                                          (
                                                                            h: any
                                                                          ) => (
                                                                            (h.isMainteanceChecked = false),
                                                                            h.hasOwnProperty(
                                                                              "children"
                                                                            )
                                                                              ? h.children.map(
                                                                                  (
                                                                                    j: any
                                                                                  ) => (
                                                                                    (j.isMainteanceChecked = false),
                                                                                    j.hasOwnProperty(
                                                                                      "children"
                                                                                    )
                                                                                      ? j.children.map(
                                                                                          (
                                                                                            k: any
                                                                                          ) => (
                                                                                            (k.isMainteanceChecked = false),
                                                                                            k.hasOwnProperty(
                                                                                              "children"
                                                                                            )
                                                                                              ? k.children.map(
                                                                                                  (
                                                                                                    l: any
                                                                                                  ) => (
                                                                                                    (l.isMainteanceChecked = false),
                                                                                                    l.hasOwnProperty(
                                                                                                      "children"
                                                                                                    )
                                                                                                      ? l.children.map(
                                                                                                          (
                                                                                                            m: any
                                                                                                          ) => (
                                                                                                            (m.isMainteanceChecked = false),
                                                                                                            m.hasOwnProperty(
                                                                                                              "children"
                                                                                                            )
                                                                                                              ? ""
                                                                                                              : ""
                                                                                                          )
                                                                                                        )
                                                                                                      : ""
                                                                                                  )
                                                                                                )
                                                                                              : ""
                                                                                          )
                                                                                        )
                                                                                      : ""
                                                                                  )
                                                                                )
                                                                              : ""
                                                                          )
                                                                        )
                                                                      : ""
                                                                  )
                                                                )
                                                              : ""
                                                          )
                                                        )
                                                      : ""
                                                  )
                                                )
                                              : ""
                                          )
                                        )
                                      : ""
                                  )
                                )
                              : ""
                          )
                        )
                      : ""
                  )
                )
              : ""
          )
        )
      : status === true
      ? childArray.map(
          (a: any) => (
            (a.isMainteanceChecked = true),
            a.hasOwnProperty("children")
              ? a.children.map(
                  (b: any) => (
                    (b.isMainteanceChecked = true),
                    b.hasOwnProperty("children")
                      ? b.children.map(
                          (c: any) => (
                            (c.isMainteanceChecked = true),
                            c.hasOwnProperty("children")
                              ? c.children.map(
                                  (d: any) => (
                                    (d.isMainteanceChecked = true),
                                    d.hasOwnProperty("children")
                                      ? d.children.map(
                                          (f: any) => (
                                            (f.isMainteanceChecked = true),
                                            f.hasOwnProperty("children")
                                              ? f.children.map(
                                                  (g: any) => (
                                                    (g.isMainteanceChecked = true),
                                                    g.hasOwnProperty("children")
                                                      ? g.children.map(
                                                          (h: any) => (
                                                            (h.isMainteanceChecked = true),
                                                            h.hasOwnProperty(
                                                              "children"
                                                            )
                                                              ? h.children.map(
                                                                  (j: any) => (
                                                                    (j.isMainteanceChecked = true),
                                                                    j.hasOwnProperty(
                                                                      "children"
                                                                    )
                                                                      ? j.children.map(
                                                                          (
                                                                            h: any
                                                                          ) => (
                                                                            (h.isMainteanceChecked = true),
                                                                            h.hasOwnProperty(
                                                                              "children"
                                                                            )
                                                                              ? h.children.map(
                                                                                  (
                                                                                    j: any
                                                                                  ) => (
                                                                                    (j.isMainteanceChecked = true),
                                                                                    j.hasOwnProperty(
                                                                                      "children"
                                                                                    )
                                                                                      ? j.children.map(
                                                                                          (
                                                                                            k: any
                                                                                          ) => (
                                                                                            (k.isMainteanceChecked = true),
                                                                                            k.hasOwnProperty(
                                                                                              "children"
                                                                                            )
                                                                                              ? k.children.map(
                                                                                                  (
                                                                                                    l: any
                                                                                                  ) => (
                                                                                                    (l.isMainteanceChecked = true),
                                                                                                    l.hasOwnProperty(
                                                                                                      "children"
                                                                                                    )
                                                                                                      ? l.children.map(
                                                                                                          (
                                                                                                            m: any
                                                                                                          ) => (
                                                                                                            (m.isMainteanceChecked = true),
                                                                                                            m.hasOwnProperty(
                                                                                                              "children"
                                                                                                            )
                                                                                                              ? ""
                                                                                                              : ""
                                                                                                          )
                                                                                                        )
                                                                                                      : ""
                                                                                                  )
                                                                                                )
                                                                                              : ""
                                                                                          )
                                                                                        )
                                                                                      : ""
                                                                                  )
                                                                                )
                                                                              : ""
                                                                          )
                                                                        )
                                                                      : ""
                                                                  )
                                                                )
                                                              : ""
                                                          )
                                                        )
                                                      : ""
                                                  )
                                                )
                                              : ""
                                          )
                                        )
                                      : ""
                                  )
                                )
                              : ""
                          )
                        )
                      : ""
                  )
                )
              : ""
          )
        )
      : "";

    disabledArray = this.systemList;

    disabledArray.map((a: any) =>
      a.categoryId === c1
        ? ((a.children = []), (a.children = childArray))
        : a.hasOwnProperty("children")
        ? a.children.map((b: any) =>
            b.categoryId === c1
              ? ((b.children = []), (b.children = childArray))
              : b.hasOwnProperty("children")
              ? b.children.map((c: any) =>
                  c.categoryId === c1
                    ? ((c.children = []), (c.children = childArray))
                    : c.hasOwnProperty("children")
                    ? c.children.map((d: any) =>
                        d.categoryId === c1
                          ? ((d.children = []), (d.children = childArray))
                          : d.hasOwnProperty("children")
                          ? d.children.map((f: any) =>
                              f.categoryId === c1
                                ? ((f.children = []), (f.children = childArray))
                                : f.hasOwnProperty("children")
                                ? f.children.map((g: any) =>
                                    g.categoryId === c1
                                      ? ((g.children = []),
                                        (g.children = childArray))
                                      : g.hasOwnProperty("children")
                                      ? g.children.map((h: any) =>
                                          h.categoryId === c1
                                            ? ((h.children = []),
                                              (h.children = childArray))
                                            : h.hasOwnProperty("children")
                                            ? h.children.map((j: any) =>
                                                j.categoryId === c1
                                                  ? ((j.children = []),
                                                    (j.children = childArray))
                                                  : j.hasOwnProperty("children")
                                                  ? j.children.map((k: any) =>
                                                      k.categoryId === c1
                                                        ? ((k.children = []),
                                                          (k.children = childArray))
                                                        : k.hasOwnProperty(
                                                            "children"
                                                          )
                                                        ? k.children.map(
                                                            (l: any) =>
                                                              l.categoryId ===
                                                              c1
                                                                ? ((l.children = []),
                                                                  (l.children = childArray))
                                                                : ""
                                                          )
                                                        : ""
                                                    )
                                                  : ""
                                              )
                                            : ""
                                        )
                                      : ""
                                  )
                                : ""
                            )
                          : ""
                      )
                    : ""
                )
              : ""
          )
        : ""
    );

    this.systemList = disabledArray;
    console.log("After asasas ---->>>>", this.systemList);
  }

  collapseEvent(e: any) {
    console.log("Event");
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }
}
